module.exports = __webpack_public_path__ + "img/edge_activites_canyoning.efbfc24f.svg";